import Transformer from "./../transformer";
import HighwaySectionTransformer from "./highwaySection";

import CustomerTransformer from "./customer";
import ChiefTransformer from "./chiefRelations";
import CustomerStaffTransformer from "./customerStaff";
import CampTransformer from "./camp";

import HighwayTransformer from "./highway";
import ExtranetHighwayTransformer from "./extranetHighway";
import HighwayCompanyTransformer from "./highwayCompany";
import HighwayDelegateTransformer from "./highwayDelegate";
import HighwayTollboothTransformer from "./highwayTollbooth";
import HighwayFullTollboothTransformer from "./highwayFullTollbooth";
import CrewTransformer from "./crew/crew";
import familyTransformer from "./supplys/family";
import subFamilyTransformer from "./supplys/subFamily";
import supplyTransformer from "./supplys/supply";
import WarehouseTransformer from "./warehouse/warehouse";

import RoadConceptJBTransformer from "./services/roadConceptJB";
import RoadConceptJBSupplyTransformer from "./services/roadConceptJBSupply";

import ProviderTransformer from "./provider";

import ConceptFileTransformer from "./conceptFile";

import SupplyValidationTransformer from "./supplyValidation";

import ConceptsCatalogTransfomer from "./services/ConceptsCatalog";

import FileTransformer from "../Files/Files";

class CurrencyTransformer extends Transformer {
  static fetch(currency) {
    return {
      name: currency.name || "",
      codename: currency.codename || "",
      id: currency.id,
      symbol: currency.symbol,
    };
  }
}

export default {
  highway: HighwayTransformer,
  "highway/extranet": ExtranetHighwayTransformer,
  currency: CurrencyTransformer,
  customer: CustomerTransformer,
  "customer/customerstaff": CustomerStaffTransformer,
  highwaycompany: HighwayCompanyTransformer,
  "highway/highwaydelegation": HighwayDelegateTransformer,
  "highway/camp": CampTransformer,
  "highway/tollbooth": HighwayTollboothTransformer,
  "highway/tollbooth/gettollbooth": HighwayFullTollboothTransformer,
  "highway/highwaysection": HighwaySectionTransformer,
  crew: CrewTransformer,
  "services/families": familyTransformer,
  "services/subfamilies": subFamilyTransformer,
  "services/supplies": supplyTransformer,
  "services/roadconceptjb": RoadConceptJBTransformer,
  "services/roadconceptjbsupply": RoadConceptJBSupplyTransformer,
  "common/file/getfile": FileTransformer,
  "common/file/get_customer_files": FileTransformer,
  "common/conceptfiles": ConceptFileTransformer,
  "common/conceptfiles/byAffected": ConceptFileTransformer,
  "common/customer_conceptfiles/byAffected": ConceptFileTransformer,
  warehouse: WarehouseTransformer,
  "services/suppliesvalidation": SupplyValidationTransformer,
  "services/catalogs": ConceptsCatalogTransfomer,
  "customer/administrative/highway": ChiefTransformer,
  "providers": ProviderTransformer
};



// WEBPACK FOOTER //
// ./src/transformers/catalog/index.js